import { generatePath } from 'react-router-dom-v5-compat';

import { USER_AGENTS_URL } from 'api/UserEventsAPI';
import { useRestQuery } from 'utils/hooks/api/useRestQuery';

import { UserKey } from '../../../domain';

type UserAgentsQueryResponse = { userAgent: string }[];

export const useUserAgentsQuery = (userKey: UserKey) => {
  const path = generatePath(USER_AGENTS_URL, { userKey });
  return useRestQuery<UserAgentsQueryResponse>(path);
};
